// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8485":"152a7fdf","8529":"0c4124b9","9993":"0c4124b9"}[chunkId] + ".chunk.css";
};